<template>
    <a
        class="l-ss-c-offer"
        :class="{
            'l-ss-c-offer-vertical': isVertical,
            'l-ss-c-offer-mobile': mobile ,
            'l-ss-c-offer-adult': isAdult,
            'l-ss-c-offer-not-available': !offer.available,
            'l-ss-c-offer-row-mini': offerLayout === 'rowMini',
            'l-ss-c-offer-column-mini': offerLayout === 'columnMini'
        }"
        :data-first-offer-id="offer.id"
        :data-offer-id="currentOffer.id"
        :data-offer-index="offerIndex"
        :href="currentOffer.url"
        :target="linkTargetBlank ? '_blank' : '_self'"
        @click="onclick">
        <offer-item
            v-for="contentItem in offerContentItems"
            :key="contentItem.key"
            :content-item="contentItem"/>
    </a>
</template>

<script>
    import { ref, watch, onBeforeUnmount, onMounted } from '@/lib/vue-composition-api.js';
    import useOfferItemsResolver from '@/core/components/offer/use-offer-items-resolver';

    import useOfferGetPriceController from '@/core/components/offer/offer-price/use-offer-get-price-controller';

    import OfferItem from '@/core/components/offer/offer-item.vue';

    import { nanoid } from 'nanoid';

    export default {
        components: {
            OfferItem,
        },
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
                required: true,
            },
            layout: {
                type: String,
                default: 'row',
            },
            offerIndex: {
                type: Number,
                required: true,
            },
            mobile: {
                type: Boolean,
                default: false,
            },
            isAdult: {
                type: Boolean,
                default: false,
            },
            linkTargetBlank: {
                type: Boolean,
                default: false,
            },
            isCartCountAvailable: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { emit, root }) {
            const { offer, settings } = props;
            const { layout: layoutSettings, cart: cartSettings } = settings;

            const currentOffer = ref(offer);

            const isShowDropdown = ref();

            let offerLayout = props.layout;
            let isVertical = offerLayout === 'column' || offerLayout === 'columnMini';
            let isMini = offerLayout === 'columnMini' || offerLayout === 'rowMini';

            const contentSettings = layoutSettings[offerLayout];

            let destroyComponentsFunc = null;

            const offerCartId = nanoid();

            const initOfferContentItems = (rerender) =>
                useOfferItemsResolver(
                    {
                        items: contentSettings,
                        offer: currentOffer.value,
                        firstOfferId: offerCartId,
                        offerSettings: {
                            ...settings,
                            mobile: props.mobile,
                            vertical: isVertical,
                            isAdult: props.isAdult,
                            isCartCountAvailable: props.isCartCountAvailable,
                            isShowDropdown,
                        },
                        on: {
                            addToCartClick: (event) => emit('add-to-cart-click', event),
                            removeFromCartClick: (event) => emit('remove-from-cart-click', event),
                            changeOffer: (event) => onChangeOfferByParam(event),
                            loadGroupedOffers: (event) => emit('load-grouped-offers', event),
                            similarClickHandler: (data) => similarClickHandler(data),
                        },
                        root,
                        rerender,
                    });

            const offerContentItems = ref([]);

            const init = (rerender) => {
                const { destroyComponents, contentItems } = initOfferContentItems(rerender);
                offerContentItems.value = contentItems;
                destroyComponentsFunc = destroyComponents;
            };

            onMounted(() => {
                init();
            });

            onBeforeUnmount(() => {
                destroyComponentsFunc();
            });

            const onclick = (event) => {
                if (event.target.closest('.l-ss-c-offer-cart-btn')) {
                    return;
                }

                emit('click', event);
            };

            const updatePrice = async () => {
                const priceData = await useOfferGetPriceController(offer, settings.getPrice);
                currentOffer.value = {
                    ...currentOffer.value,
                    price: priceData.price,
                    oldPrice: priceData.oldPrice,
                };

                init(['price', 'labels']);
            };

            if (settings.getPrice) {
                updatePrice();
            }

            const similarClickHandler = (data) => {
                isShowDropdown.value = data;
            };

            const onChangeOfferByParam = (offer) => {
                currentOffer.value = offer;
                init(true);
            };

            watch(() => props.isAdult, () => {
                init();
            });

            return {
                currentOffer,
                cartSettings,
                offerContentItems,
                isVertical,
                offerLayout,
                isMini,
                onclick,
            };
        },
    };

</script>

<!--<template>
    <div class="l-ss-c-offer-inner">
        <a
            :href="offer.url"
            :target="$configuration.linkTargetBlank ? '_blank' : '_self'"
            class="decoration-none"
            @mouseup="handleClick">
            <div class="l-ss-c-offer-labels">
                <div
                    v-for="label in labels"
                    class="l-ss-c-offer-label-wrapper">
                    <span
                        :class="[`l-ss-c-offer-label-type-${label.id}` , { 'l-ss-c-offer-label-type-available': label.id === 'available' || offer.available }]"
                        class="l-ss-c-offer-label l-ss-c-offer-label-text">
                        {{ $t(`labels.${label.id}`, null, label.title) }}
                    </span>
                </div>
                <div
                    class="l-ss-c-offer-thumbnails-navigation"
                    v-if="hasMultipleImages">
                    <button
                        @click.stop.prevent=""
                        data-v-action="nextImage"
                        class="l-ss-c-offer-thumbnails-navigation-right"
                        :class="{ 'l-ss-c-offer-thumbnails-navigation-right-mobile': $screen.isMobile }">
                        <i
                            class="icon-white"
                            v-html="arrowDownIcon"></i>
                    </button>
                </div>
            </div>
            <div class="l-ss-c-offer-thumbnails">
                <span
                    v-if="!hasImages && !errorCustomImg"
                    class="l-ss-c-offer-thumbnail l-ss-c-offer-thumbnail-no-photo l-ss-c-offer-thumbnail-is-active"
                    v-html="noPhotoURL">
                </span>
                <span
                    v-if="!hasImages && errorCustomImg"
                    :style="`background-image: url(${noPhotoURL});`"
                    class="l-ss-c-offer-thumbnail l-ss-c-offer-thumbnail-no-photo l-ss-c-offer-thumbnail-is-active">
                </span>
                <template v-if="hasImages">

                    <div
                        v-for="(image, imageIndex) in offer.pictures"
                        :class="{ 'l-ss-c-offer-thumbnail-is-active': hasLoadedImage && imageIndex === activeImageIndex }"
                        :style="hasLoadedImage && imageIndex === activeImageIndex ? `background-image: url(${image});` : ''"
                        class="l-ss-c-offer-thumbnail">
                        <img
                            :key="`${activeImageIndex}-${imageIndex}`"
                            :ref="`thumbnail-${imageIndex}`"
                            :data-index="imageIndex"
                            :data-src="image"
                            :src="image"
                            class="l-ss-c-offer-thumbnail-image"
                            loading="lazy"
                            @error="errorImgListener"
                            @load="() => handleImageLoad(imageIndex)">
                    </div>
                </template>
            </div>
            <div class="l-ss-c-offer-info">
                <h4 class="l-ss-c-offer-info-title">
                    <span
                        v-html="name"
                        ref="offerName"></span>
                    <div
                        v-if="isShowNameTooltip"
                        class="l-ss-c-offer-info-title-tooltip"
                        ref="offerNameTooltip">
                        <span v-html="offer.name"></span>
                    </div>
                </h4>
                <div class="l-ss-c-offer-info-wrapper">
                    <span
                        v-if="$configuration.showOfferSku && offer.offerCode"
                        class="l-ss-c-offer-caption"
                        :title="offer.offerCode">
                        {{ $t('vendorCode') }} {{ offer.offerCode }}
                    </span>
                    <span
                        v-if="$configuration.showOfferCount && offer.count && false"
                        :title="offer.count"
                        class="l-ss-c-offer-instock">
                        {{ $t('inStock', { pieces: offer.count }) }}
                    </span>
                    <span
                        v-if="snippet"
                        :title="snippet"
                        class="l-ss-c-offer-caption">
                        {{ snippet }}
                    </span>
                    <div
                        v-if="(starItems || []).length > 0"
                        class="l-ss-c-offer-stars-wrapper">
                        <div class="l-ss-c-offer-stars-list">
                            <span
                                v-for="(type, index) in starItems"
                                :key="`offer-${offer.id}-star-${index}`"
                                class="l-ss-c-offer-stars-list-item"
                                v-html="starIconsByType[type]"></span>
                        </div>
                        <span
                            v-if="reviewCount">{{ reviewCount }}
                            <span
                                v-if="starItems.length === 0">{{ $t('reviewCountPostfix').toLowerCase() }}</span></span>
                    </div>
                </div>
            </div>
        </a>
        <div class="l-ss-c-offer-footer-actions">
            <div class="l-ss-c-offer-footer">
                <div class="l-ss-c-offer-footer">
                    <price :offer="offer"/>
                </div>
            </div>
            <cart
                :count="count"
                :show-cart-button="showCartButton"
                :offer="offer"
                @add-to-cart="(payload) => $emit('add-to-cart', payload)"/>
        </div>
    </div>
</template>-->

